export const DatasetLabel: Record<string, string> = {
  OigExclusions: 'OIG Exclusions',
  OigFugitives: 'OIG Fugitives',
  OfacSdn: 'OFAC SDN',
  OfacConsolidated: 'OFAC Consolidated',
  Sam: 'SAM Exclusions',
  MedicareOptOut: 'Medicare Opt-Out',
  StateSanctionsAndExclusions: 'State Sanctions and Exclusions',
  Dmf: 'SSA DMF',
  Npdb: 'NPDB',
  CmsPreclusion: 'CMS Preclusion List',
  Tricare: 'TRICARE'
};
